import { HeadingComponentConfig } from '@rappider/rappider-components/utils';
import { defaultToolbarTitleHeadingSize } from '@rappider/shared/definitions';

/**
 * Project modules section title configuration
 */
export const projectModuleTitle: HeadingComponentConfig = {
  content: 'Project Modules',
  type: defaultToolbarTitleHeadingSize
};

/**
 * Breadcrumb navigation for project modules section
 */
export const projectModuleOptiontitle = [
  {
    label: 'Project',
    redirectUrl: '/projects'
  },
  {
    label: 'Project Modules'
  }
];
